import React from 'react'
import { map } from 'lodash'
import { staffs } from '../clients/iron-fit'

export const StaffNameWithIcon: React.FC<{ staffId: string; videoStatus?: string; microphoneStatus?: string }> = ({
  staffId,
  videoStatus,
  microphoneStatus,
}) => {
  const [staff] = staffs.useStaff(staffId)
  const title = React.useMemo(() => map(staff?.corporationIds, (v, id) => id).join(', '), [staff])
  if (!staff) return null
  return (
    <div className="d-flex">
      <span title={title}>
        <div className="d-flex align-items-center">
          <i className="fa-solid fa-stethoscope"></i><div className='d-block'>{staff?.department === "Pediatrician" ? '👶' : ""}</div>
          <strong className="text-truncate fixedwidth monitor-staff-name" title={title}>{staff.name}</strong>
        </div>
      </span>
      {(videoStatus || microphoneStatus) && (
        <div className="d-flex">
          {videoStatus && (
            <div className="mr-2">
              {videoStatus === 'offline' && <i className="fas fa-video text-danger"></i>}
              {videoStatus === 'enabled' && <i className="fas fa-video text-success"></i>}
              {videoStatus === 'disabled' && <i className="fas fa-video-slash text-warning"></i>}
            </div>
          )}
          {microphoneStatus && (
            <div className="mr-2">
              {microphoneStatus === 'offline' && <i className="fas fa-microphone text-danger"></i>}
              {microphoneStatus === 'enabled' && <i className="fas fa-microphone text-success"></i>}
              {microphoneStatus === 'disabled' && <i className="fas fa-microphone-slash text-warning"></i>}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
